export const setAuthHeader = (token, additional) => ({
  Authorization: `Bearer ${token}`,
  ...additional
});
